"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _excluded = ["size", "picture"];

var RoundImage = _styledComponents["default"].img.withConfig({
  displayName: "Avatar__RoundImage",
  componentId: "sc-5m5gtj-0"
})(["border-radius:50%;object-fit:cover;"]);

var Avatar = function Avatar(_ref) {
  var size = _ref.size,
      picture = _ref.picture,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(RoundImage, (0, _extends2["default"])({
    width: size + "px",
    height: size + "px",
    style: {
      objectFit: "cover"
    },
    src: picture,
    bg: "dark.4",
    alt: "Profile Picture"
  }, props));
};

Avatar.defaultProps = {
  size: 40
};
Avatar.propTypes = (0, _extends2["default"])({}, _Flex["default"].propTypes, {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  picture: _propTypes["default"].string.isRequired
});
var _default = Avatar;
exports["default"] = _default;